import { animated, useSpring } from '@react-spring/web';

const Counter = ({
  value,
  prefix = '',
  suffix = '%',
  color = '#FFFFFF',
  fontSize = '30px',
  style
}: {
  value: number;
  prefix?: string;
  suffix?: string;
  color?: string;
  fontSize?: string
  style?: React.CSSProperties
}) => {
  const { number } = useSpring({
    from: { number: 0 },
    to: { number: value },
    config: { duration: 500, bounce: 0.5 }
  });
  return <animated.p className={' text-white font-semibold self-center '} style={ {
    color,
    fontSize,
    ...style
  }}>
    {number.to(n => `${prefix}${Math.floor(n)}${suffix}`)}
  </animated.p>;
};

export default Counter;
